import PropTypes from 'prop-types';
import ParticipantItemImpl from './participant-item.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component that displays a participant's name with an optional team logo/icon.
 * Supports displaying short names when team logo is shown, and can optionally
 * display starting pitcher names for baseball events.
 *
 * @class ParticipantItem
 * @memberof Mojito.Presentation.Components
 */

/**
 * ParticipantItem prop types.
 *
 * @property {string} sportId - Sport id for team icon.
 * @property {object} participant - The participant.
 * @property {Function} [updateTeamValidIcons] - Callback for tracking team icon validity.
 * @property {boolean} [hasTeamLogo = true ] - Runtime flag indicating that a team logo is available to display.
 * @property {string} [src] - Source of the team icon.
 *
 * @memberof Mojito.Presentation.Components.ParticipantItem
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    participant: PropTypes.object.isRequired,
    updateTeamValidIcons: PropTypes.func,
    hasTeamLogo: PropTypes.bool,
    src: PropTypes.string,
};

const defaultProps = {
    participant: {},
    updateTeamValidIcons: noop,
    hasTeamLogo: true,
};

export default UIView('ParticipantItem', ParticipantItemImpl, propTypes, defaultProps);
